import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DoctorsService } from '../shared/doctor-service/doctors.service';
import { AuthService } from '../auth-section/auth-service/auth.service';
import { take } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.css']
})
export class MembersComponent implements OnInit {
  personForm: FormGroup;
  token: any
  id:any
  doctype:any
  members: any;
  clinicId:any;
  moment = moment;
  singleId:any
  @ViewChild('cls', { static: false }) cref: ElementRef;
  clinicArray: any[];
  curIndex: number;
  clinicData: any;
  changeable: boolean;
  clinicName: any;
  selectedMemberIndex: number= null;
  startDate:any = new Date(); // Store the selected start date
  endDate: any = new Date(); //
  startDatefinal:String = moment().format('DD/MM/YYYY');; // Store the selected start date
  endDatefinal: String = moment().format('DD/MM/YYYY');; //
  items: { name: string }[] = [
    { name: 'Item 1' },
    { name: 'Item 2' },
    { name: 'Item 3' },
    { name: 'Item 4' },
    { name: 'Item 5' }
  ];

  dropdownOpen: boolean[] = [];
  onChangeStartDate(startDate){
    console.log("this is startDate",startDate);
    this.startDatefinal = moment(startDate).format('DD/MM/YYYY');
    
  }
  onChangeEndDate(endDate){
      // Use DatePipe to format the selected date
      this.endDatefinal = moment(endDate).format('DD/MM/YYYY');
    console.log("this is enddate",endDate);
    
  }
  toggleDropdown(index: number) {
    console.log("this is index",index);
    
    // Toggle the dropdown for the specified index
    this.dropdownOpen[index] = true;

    // Close all other dropdowns
    for (let i = 0; i < this.dropdownOpen.length; i++) {
      if (i !== index) {
        this.dropdownOpen[i] = false;
      }
    }
    console.log("this is dropdown array",this.dropdownOpen);
    
  }
  constructor(private fb: FormBuilder,private doctorservice: DoctorsService,
    private authService:AuthService) {
   
  }

  ngOnInit(): void {
    this.authService.authDataSubject.pipe(take(1)).subscribe((auth) => {
      this.token = auth._token;
      this.id = auth._id;
      this.doctype = auth._type;
      // this.gelAllClinic();
    }); 

    this.clinicId = JSON.parse(localStorage.getItem('activeClinic'));
    console.log("clinicId -=-=-=-=-=-=-=-=>>>>>>>>.",this.clinicId);
    this.personForm = this.fb.group({
      name: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      email: ['', Validators.required],
      price: [ '', Validators.required]
    });
    // 
    // this.getClinicDetails()
    this.getClinic();
  }

  getClinic(){
    this.doctorservice.getAllClinic(this.id, this.token).subscribe((res:any)=>{
      this.clinicName = res.clinics[0].clinicName;
      this.clinicData = res.clinics[0];
      this.clinicArray = res.clinics;
      this.clinicId = this.clinicData._id;
      this.getMember(this.clinicId)
      console.log(this.clinicName, "this is clinic from member side")
    })
  }
  onChangeClinic(index){
    this.clinicData = this.clinicArray[index];
    this.clinicId = this.clinicData._id;
    this.getMember(this.clinicId)
  }
  toggleDateDropdown(index: number) {
    // Toggle the date dropdown for the selected member
    if (this.selectedMemberIndex === index) {
      this.selectedMemberIndex = null;
    } else {
      this.selectedMemberIndex = index;
    }
  }
  addPerson(): void {
    let dt = this.personForm.value;
    let payload = {
      name : dt.name,
      phoneNumber : dt.phoneNumber,
      email : dt.email,
      clinicId: this.clinicId
    }
    this.doctorservice.addMember(payload,this.token).subscribe((res:any)=>{
      console.log(res);
      this.getMember(this.clinicId);
      this.cref.nativeElement.click();
    })
  }

  // getClinicDetails(){
  //   this.doctorservice.getClinicDetails(this.clinicId,this.token).subscribe((res:any)=>{
  //     console.log("all clinic data",res)
  //   })
  // }

  getMember(clinicId){
    this.doctorservice.getMember(clinicId,this.token).subscribe((res:any)=>{
      console.log(res);
      this.members= res;
    })
  }

  deleteMember(data){
    console.log(data);
    this.singleId = data._id
    this.doctorservice.deletMember(this.singleId,this.token).subscribe((res:any)=>{
      console.log(res);
      this.getMember(this.clinicId);
    })
  }
  closelistView(index){
   this.dropdownOpen[index] = false;
  }
  getMembersByName(event){
    console.log(event.target.value);
    if(event.target.value){
      this.doctorservice.getMembersByName(this.clinicId,event.target.value,this.token).subscribe((res:any)=>{
        this.members = res;
      })
    }else{
      this.getMember(this.clinicId)
    }
  }
}
